<div class="view-container">
  <div class="renderer-pools">
    <mat-card>
      <mat-card-content>
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px"
          fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
          <label>Renderer Pools</label>
          <button mat-flat-button color="primary" (click)="createPool()" *ngIf="admin">
            <mat-icon>add</mat-icon> Create Pool
          </button>
        </div>

        <mat-card class="contrast" *ngFor="let pool of poolsDataSource.data"
          [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
            <div fxFlex="70" fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="5px">
              <strong [ngClass.lt-sm]="{'card-title': true}" [matTooltip]="pool?.id">{{ pool?.name }}</strong>
            </div>
            <div fxFlex="30" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap.lt-sm="18px">
              <div fxFlex fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="10px">
                <button mat-icon-button color="primary" matTooltip="View renderers in pool" 
                  (click)="viewPool(pool)">
                  <mat-icon>visibility</mat-icon>
                </button>
                <button mat-icon-button color="accent" matTooltip="Edit pool" 
                  (click)="editPool(pool)" *ngIf="admin">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" matTooltip="Delete pool" 
                  (click)="deletePool(pool)" *ngIf="admin">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <div class="no-data mat-card contrast" *ngIf="!loading && poolsDataSource.data.length === 0"
          [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-card-content>
            <mat-icon>pool</mat-icon>
            <p>No renderer pools found</p>
          </mat-card-content>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<app-spinner *ngIf="loading"></app-spinner>